module.exports = __webpack_public_path__ + "36488fbe200f5f93a6c7b6a5b0dcd944.mp3";